export default __webpack_public_path__ + "static/showdown-e644259ec4453d2352956f19c377915c.jpg";